import { createContext, useContext } from 'react';
import type { MeResponse } from './api';

/**
 * The signed-in user + memberships, provided once at the router root so the
 * app shell (AppLayout's desktop rail) can read membership/moderator/founder
 * state for its nav without prop-drilling. Pages that already receive `me`
 * as a prop keep doing so; this is purely for the chrome.
 */
export const MeContext = createContext<MeResponse | null>(null);

export function useMe(): MeResponse | null {
  return useContext(MeContext);
}
